<template>
  <div class="quote" :style="{ backgroundImage: `url(${orgBackground})`}">
    <div class="header">
      <div class="iconBox" @click="toOrderList">
        <img :src="orderBtn" alt="">
        <span>我的订单</span>
      </div>
    </div>
    <div class="form_info">
      <div class="info_title">
        <img :src="zsb_H5MotorQuote_info" alt="">
        <span>报价信息</span>
      </div>
      <div class="info_content">
        <van-cell-group :border="false">
          <van-field
          label="交强险起期"
            :value="`${startDateCI} ${startHourCI}时${startMinuteCI}分`"
            input-align="right"
            clickable
            required
            readonly
            is-link
            @click="openStartDate"
          />
          <van-field
            label="交强险止期"
            :value="`${endDateCI} ${endHourCI}时${endMinuteCI}分`"
            input-align="right"
            disabled
            required
            readonly
            is-link
          />
          <van-popup
            v-model="popupTimeVisible"
            position="bottom"
            close-on-click-overlay
          >
            <van-datetime-picker
              type="datetime"
              :value="currentDate"
              :min-date="minDate"
              @confirm="sureHour"
              @cancel="popupTimeVisible = false"
            />
          </van-popup>
        </van-cell-group>
      </div>
    </div>
    <div class="form_info">
      <div class="info_title" style="padding-bottom: 0.1rem; border-bottom: 0.01rem solid #ebedf0">
        <span>交强险</span>
      </div>
      <div class="info_content padding_content">
        <van-cell-group :border="false">
          <van-cell title="保额" :value="JQAmount" input-align="right" />
          <van-cell title="保费" input-align="right" :value="sumPremiumCI" value-class="cell_color" />
          <!-- <van-cell title="手续费" input-align="right" :value="cHandleFee" value-class="cell_color" /> -->
        </van-cell-group>
      </div>
    </div>
    <div class="form_info" :style="{'margin-bottom': comName==='HU_NAN' ? '.8rem':''}">
      <div class="info_title" style="padding-bottom: 0.1rem; border-bottom: 0.01rem solid #ebedf0;display: flex;justify-content: space-between;">
        <span>车船税</span>
        <span v-if="isCarShipSwitch" style="color:#F29600;font-size:14px;margin-right:14px">{{ taxRelifInfo.sumPayTax }}</span>
      </div>
      <div class="info_content tax_content">
        <van-cell-group :border="false">
          <van-field v-model="taxRelifFlagName" label="车船税" input-align="right" is-link required readonly @click="showTaxRelif = true" v-if="isCarShipSwitch && taxRelifInfo.sumPayTax!=='报价后可见'"/>
          <van-field v-model="taxRelifFlagName" label="车船税" input-align="right" is-link required readonly @click="showTaxRelif = true"  v-if="!isCarShipSwitch"/>
          <div v-if="taxRelifInfo.taxRelifFlag!='6'">
            <van-field v-if="['1','3'].includes(taxRelifInfo.taxRelifFlag) && !isCarShipSwitch" v-model="calculateModeName" label="计算类别" input-align="right" is-link required readonly @click="showCalculateMode = true" />

            <van-field v-if="['1','2','3'].includes(taxRelifInfo.taxRelifFlag) && !isCarShipSwitch" v-model="taxRelifInfo.taxpayerIdentifier" label="纳税人识别号" placeholder="纳税人为个人时请录入身份证号" input-align="right" required class="shibei" @blur.native.capture="checkIdentityNumber(taxRelifInfo.taxpayerIdentifier)" />
            <van-field v-if="taxRelifInfo.taxRelifFlag=='3'" v-model="taxRelifInfo.taxRelief" label="减免税额（￥）" input-align="right" type="number" required placeholder="请输入减免税额" />

            <van-field v-if="['2','3'].includes(taxRelifInfo.taxRelifFlag)" v-model="taxRelifInfo.extendChar2" :label="isCarShipSwitch ? '免税凭证号' : '减免税凭证号'" input-align="right" required placeholder="请输入凭证号" @input="extendCharInput" />

            <van-field v-if="taxRelifInfo.taxRelifFlag=='2'" v-model="relifReasonMainName" label="免征原因" input-align="right" is-link required readonly @click="showReasonMain = true" />

            <van-field v-if="taxRelifInfo.taxRelifFlag=='2'&& isCarShipSwitch" v-model="freeRateTextName" label="免税方案代码" input-align="right" is-link required readonly @click="showFreeRateText = true" />

            <van-field v-if="taxRelifInfo.taxRelifFlag=='3'" v-model="taxRelifInfo.freeRateText" label="减免说明" input-align="right" required placeholder="请输入减免说明" @input="freeRateTextInput"/>

            <van-field v-if="taxRelifInfo.taxRelifFlag=='3'" v-model="relifReasonName" label="减税原因" input-align="right" is-link required readonly @click="showReasonTax = true" />

            <van-field v-if="taxRelifInfo.taxRelifFlag=='4'" v-model="taxRelifInfo.paidFreeCertificate" label="完税凭证号" input-align="right" required placeholder="请输入完税凭证号"/>

           <div v-if="isCarShipSwitch">
              <van-field v-if="taxRelifInfo.taxRelifFlag=='4'" v-model="taxRelifInfo.taxDocumentDate" label="完税凭证填发日期" input-align="right" is-link readonly @click="taxTimeVisible = true" />
              <van-field v-if="taxRelifInfo.taxRelifFlag=='4'" v-model="TaxPaidAreaName" label="开具完税凭证地区名称" input-align="right" is-link readonly @click="showTaxPaidCode = true"/>
           </div>

            <van-field v-if="['1','3'].includes(taxRelifInfo.taxRelifFlag) && taxRelifInfo.calculateMode!='2'&& !isCarShipSwitch" v-model="taxRelifInfo.payLastYear" label="前次缴费年度" input-align="right" is-link required readonly @click="showYear = true" />
            <van-field v-if="['1','3'].includes(taxRelifInfo.taxRelifFlag) && taxRelifInfo.calculateMode!='2'&& !isCarShipSwitch" v-model="taxRelifInfo.lastCIPaymentTime" label="前次交强险止期" input-align="right" is-link required readonly @click="lastTimeVisible = true" />
            <van-cell v-if="taxRelifInfo.taxRelifFlag=='3'" title="年单位税额（￥）" input-align="right" :value="taxRelifInfo.taxDue" value-class="cell_color" />
            <van-cell v-if="['1','3'].includes(taxRelifInfo.taxRelifFlag)&& !isCarShipSwitch" title="当年应缴（￥）" input-align="right" :value="taxRelifInfo.taxActual" value-class="cell_color" />
            <van-cell v-if="['1','3'].includes(taxRelifInfo.taxRelifFlag)&& !isCarShipSwitch" title="往年补缴（￥）" input-align="right" :value="taxRelifInfo.previousPay" value-class="cell_color" />
            <van-cell v-if="['1','3'].includes(taxRelifInfo.taxRelifFlag)&& !isCarShipSwitch" title="滞纳金（￥）" input-align="right" :value="taxRelifInfo.lateFee" value-class="cell_color" />
            <van-cell v-if="['1','3'].includes(taxRelifInfo.taxRelifFlag)&& !isCarShipSwitch" title="合计（￥）" input-align="right" :value="taxRelifInfo.sumPayTax" value-class="cell_color" />
            <div v-if="!isCarShipSwitch">
               <van-field v-model="taxRelifInfo.taxComCode" label="开具税务机关代码" placeholder="请输入" input-align="right"  @input="textCodeInput"/>
              <van-field v-model="taxRelifInfo.taxComName" label="开具税务机关名称" placeholder="请输入" input-align="right" :required="isCarShipSwitch && (taxRelifInfo.taxRelifFlag=='2' || taxRelifInfo.taxRelifFlag=='4')" @input="taxComNameInput"/>
            </div>
            <div v-if="isCarShipSwitch && taxRelifInfo.taxRelifFlag!=='1'&& taxRelifInfo.taxRelifFlag!=='5'">
               <van-field v-model="taxRelifInfo.taxComCode" label="开具税务机关代码" placeholder="请输入" input-align="right" @input="textCodeInput"/>
              <van-field v-model="taxRelifInfo.taxComName" label="开具税务机关名称" placeholder="请输入" input-align="right" :required="isCarShipSwitch &&(taxRelifInfo.taxRelifFlag=='2' || taxRelifInfo.taxRelifFlag=='4')" @input="taxComNameInput"/>
            </div>
          </div>
        </van-cell-group>
      </div>
    </div>
    <div class="form_info form_bottom" v-if="isjiacheng">
      <div class="info_title flex_title">
        <span>驾驶人意外险</span>
        <van-switch v-model="checkedAccident" active-color="#5E2589" inactive-color="#dcdee0" size="20px" />
      </div>
      <div v-show="checkedAccident" class="info-content padding_content">
        <van-cell-group :border="false">
          <van-field label="方案" v-model="accidentKindInfo.projectName" input-align="right" is-link readonly @click="showProductDetail = true"></van-field>
          <van-field label="保险起期" :value="`${startDateCI} ${startHourCI}时${startMinuteCI}分`" input-align="right" clickable readonly></van-field>
          <van-field label="保障期限" v-model="selectProductInfo.projectDate" readonly input-align="right"></van-field>
           <van-field label="保费" readonly input-align="right">
            <template #input>
              <span class="money_span"> {{ selectProductInfo.sumPremium }}</span>
            </template>
          </van-field>
          <van-field label="保额" readonly input-align="right">
            <template #input>
              <span class="money_span">{{ selectProductInfo.sumAmount }}</span>
            </template>
          </van-field>
          <van-field label="投保份数" v-model="selectProductInfo.quantity" @click="showQuantity = true" input-align="right" readonly is-link></van-field>
        </van-cell-group>
      </div>
    </div>
    <div class="bottom_box">
      <div class="content_box">
        <p>总保费：<span class="sum_box">{{ sumPremium }}</span></p>
        <div class="btn">
          <div class="quote_btn" @click="toQuote">
            报价
          </div>
          <div class="next_btn" @click="goNext">
            下一步
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="showTaxRelif" position="bottom">
      <van-picker
        show-toolbar
        :columns="isCarShipSwitch ? MotorcycleTaxRelifClounmNB : MotorcycleTaxRelifClounm"
        @confirm="confirm($event,'taxRelif')"
        @cancel="showTaxRelif = false"
      />
    </van-popup>
    <van-popup v-model="showCalculateMode" position="bottom">
      <van-picker
        show-toolbar
        :columns="calculateModeCloumn"
        @confirm="confirm($event,'calculateMode')"
        @cancel="showCalculateMode = false"
      />
    </van-popup>
    <van-popup v-model="showReasonTax" position="bottom">
      <van-picker
        show-toolbar
        :columns="motorcycleReasonsTax"
        @confirm="confirm($event,'reasonTax')"
        @cancel="showReasonTax = false"
      />
    </van-popup>

    <van-popup v-model="showTaxPaidCode" position="bottom">
      <van-picker
        show-toolbar
        :columns="TaxPaidAreaCodes"
        @confirm="confirm($event,'TaxPaidShow')"
        @cancel="showTaxPaidCode = false"
      />
    </van-popup>

    <van-popup v-model="showFreeRateText" position="bottom">
      <van-picker
        show-toolbar
        :columns="freeRateTextList"
        @confirm="confirm($event,'freeRateText')"
        @cancel="showFreeRateText = false"
      />
    </van-popup>

    <van-popup v-model="showReasonMain" position="bottom">
      <van-picker
        show-toolbar
        :columns="isCarShipSwitch ? motorcycleRelifReasonNB : motorcycleRelifReason"
        @confirm="confirm($event,'reasonMain')"
        @cancel="showReasonMain = false"
      />
    </van-popup>
    <van-popup v-model="showYear" position="bottom">
      <van-picker
        show-toolbar
        :columns="yearOption"
        @confirm="confirm($event,'year')"
        @cancel="showYear = false"
      />
    </van-popup>
    <van-popup v-model="lastTimeVisible" position="bottom" close-on-click-overlay>
      <van-datetime-picker
        v-model="lastDate"
        type="date"
        :min-date="mDate"
        :max-date="maDate"
        @confirm="lastTimeSure"
        @cancel="lastTimeVisible = false"
      />
    </van-popup>

    <van-popup v-model="taxTimeVisible" position="bottom" close-on-click-overlay>
      <van-datetime-picker
        v-model="taxDocumentDate"
        type="date"
        title="选择年月日"
        :min-date="minTaxDate"
        :max-date="maxTaxDate"
        @confirm="taxDocumentTimeSure"
        @cancel="taxTimeVisible = false"
      />
    </van-popup>
    <van-popup v-model="showProductDetail" class="productModel" :close-on-click-overlay="false">
      <div class="product_box">
        <div class="title">驾驶人意外险</div>
        <div class="content">
          <van-radio-group v-model="selectRadio">
            <van-radio v-for="item in productInfoList" :key="item.projectCode" @click="selectProduct(item)"  :name="item.projectCode" checked-color="#5E2589">
              <div class="product_detail">
                <div class="detail_title">{{ item.projectName }}</div>
                <div class="detail_content" v-html="item.projectDesc.replace(/\n/g,'<br/>')"></div>
              </div>
            </van-radio>
          </van-radio-group>
        </div>
        <div class="bottom">
          <span @click="selectSure">确定</span>
        </div>
      </div>
      <div class="icon">
        <van-icon name="clear" @click="cancelSelect" />
      </div>
    </van-popup>
     <van-popup v-model="showQuantity" position="bottom">
      <van-picker
        show-toolbar
        :columns="quantityColum"
        @confirm="confirm($event,'quantity')"
        @cancel="showQuantity = false"
      />
    </van-popup>
    <van-popup v-model="isVehicle" class="veModel" :close-on-click-overlay="false">
      <div class="veTop">
        <div v-show="veImgCI">
          <div class="text">请输入交强险查询校验码</div>
          <div class="veCon">
            <div><img :src="veImgCI" alt="" class="imgCon"></div>
            <div><van-field v-model="veCodeCI" placeholder="请输入" class="fileCon" /></div>
          </div>
        </div>
        <div style="margin-top:.1rem" v-show="veImg">
          <div class="text">请输入商业险查询校验码</div>
          <div class="veCon">
            <div><img :src="veImg" alt="" class="imgCon"></div>
            <div><van-field v-model="veCode" placeholder="请输入" class="fileCon"/></div>
          </div>
        </div>
      </div>
      <div class="btnCon">
        <div @click="veCancal">取消</div>
        <div @click="toQuote">提交</div>
      </div>
    </van-popup>
    <Loading :switchs="switchs" />
  </div>
</template>

<script>
import api from '@/api/api'
import checkFormat from '@/utils/checkFormat.js'
import commonUtils from '@/utils/common.js'
import { itemKindList, areaDetail } from '@/utils/const.js'
import Loading from '@/components/Loadings/Loading'
import { removeWatermark, setWaterMark } from '../../watermark'
export default {
  components: {
    Loading
  },
  data() {
    return {
      // 转保
      basePartList: null,
      demandNo:'', //商业
      demandNoCI:'',//交强
      veCodeCI:'', //交强转保验证码
      veCode:'', //商业转保验证码
      isVehicle: false, //是否弹出转保框
      veImgCI:'', // 交强base64转图片
      veImg:'', // 商业base64转图片
      // 转保
      orderBtn: api.imgAllUrlZSB + '/order-btn.png',
      orgBackground: '',
      switchs: false,
      isQuote: false, // 是否报价-----报价页面修改任何数据都需要重新报价
      startDateCI: '',
      endDateCI: '',
      startHourCI: '00',
      startMinuteCI: '00',
      endHourCI: '24',
      endMinuteCI: '00',
      popupTimeVisible: false,
      currentDate: '',
      minDate: '',
      startTime: '',
      endTime: '',
      JQAmount: '20万元', // 交强险保额
      sumPremiumCI: '报价后可见', // 交强险保费
      // cHandleFee: '报价后可见', // 交强险手续费
      taxRelifInfo: {
        taxRelifFlag: '1', // 车船税1、正常缴税2、免税3、减税4、完税6、暂不缴税、5不征
        calculateMode: '1', // 计算类别
        taxpayerIdentifier: '', // 纳税人识别号
        payLastYear: '', // 前次缴费年度
        lastCIPaymentTime: '', // 前次交强险止期
        taxActual: '报价后可见', // 当年应缴
        previousPay: '报价后可见', // 往年补缴
        lateFee: '报价后可见', // 滞纳金
        sumPayTax: '报价后可见', // 总税费
        taxComCode: '', // 开具税务机关代码
        taxComName: '', // 开具税务机关名称
        relifReason: '', // 减免原因
        freeRateText: '', // 减免说明
        relifReasonMain: '', // 减免原因
        taxRelief: '', // 减免比例/减免金额
        paidFreeCertificate: '', // 完税凭证号
        extendChar2: '', // 减免税凭证号
        taxDue: '报价后可见', // 年单位税额
        taxDocumentDate: '', // 完税凭证填发日期
        taxPaidAreaCode: '' // 开具完税凭证地区代码

      }, // 车船税信息
      sumPremium: '报价后可见',
      showTaxRelif: false,
      MotorcycleTaxRelifClounm: [],
      MotorcycleTaxRelifClounmNB: [],
      taxRelifFlagName: '正常缴税',
      showCalculateMode: false,
      calculateModeCloumn: [],
      calculateModeName: '使用一年以上车辆',
      yearOption: [],
      showYear: false,
      lastDate: new Date(),
      lastTimeVisible: false,
      mDate: new Date(2020, 0, 1),
      maDate: new Date(),
      motorcycleReasonsTax: [], // 减税原因
      showReasonTax: false,
      motorcycleRelifReasonNB: [], // 免征原因
      motorcycleRelifReason: [], // 免征原因
      showReasonMain: false,
      relifReasonMainName: '', // 免征原因名称
      relifReasonName: '', // 减税原因
      zsb_H5MotorQuote_info: api.imgAllUrlZSB + '/zsb_H5MotorQuote_info.png',
      cInfo: '',
      proposalAreaCode: '',
      itemKindList: [],
      TaxPaidAreaCodes: [], // 完税地区
      TaxPaidAreaName: '', // 完税地区名称
      showTaxPaidCode: false, // 完税地区选择框
      taxDocumentDate: new Date(), // 完税凭证填发日期
      minTaxDate: new Date(2000, 0, 1),
      maxTaxDate: new Date(),
      taxTimeVisible: false,
      comName: '',
      freeRateTextList: [], // 免税方案代码
      showFreeRateText: false,
      freeRateTextName: '',
      proposalCityCode: '',
      isRelif: false,
      isCarShipSwitch: false,
      checkedAccident: true, // 是否选择意外险
      accidentKindInfo: {},
      productInfoList: [],
      selectProductInfo: {
        projectDate: '1年',
        insureGradeNo: '',
        quantity: '1',
        riskCode: '',
        riskName: '',
        sumAmount: '',
        sumPremium: ''
      },
      selectRadio: '',
      showCopies: false ,// 是否展示份数
      showProductDetail: false,
      showQuantity: false,
      quantityColum: [],
      isjiacheng: false, // 是否显示驾乘
    }
  },
  watch: {
    // 'taxRelifInfo.taxComCode'() {
    //   console.log('1')
    //   this.isQuote = false
    // },
    // 'taxRelifInfo.taxComName'() {
    //   console.log('12')
    //   this.isQuote = false
    // },
    'taxRelifInfo.taxpayerIdentifier'(newVal, oldVal) {
      console.log('12', newVal, oldVal)
      if (!newVal){
        this.isQuote = false
      }
    },
    // 'taxRelifInfo.relifReason'() {
    //   console.log('4')
    //   this.isQuote = false
    // },
    // 'taxRelifInfo.freeRateText'() {
    //   console.log('5')
    //   this.isQuote = false
    // },
    'taxRelifInfo.relifReasonMain': function(newVal, oldVal) {
      this.isQuote = false
    },
    'taxRelifInfo.taxRelief'() {
      this.isQuote = false
    },
    'taxRelifInfo.paidFreeCertificate'() {
      if (this.taxRelifFlagName === '完税') {
        this.isQuote = false
      }
    },
    // 'taxRelifInfo.extendChar2'(newVal, oldVal) {
    //   console.log(newVal, oldVal)
    // }
    'checkedAccident': {
     handler(newValue) {
      console.log(newValue, 'checkedAccidentnewValue')
      this.sumPremium = newValue ? this.accidentKindInfo.sumPremium : '报价后可见'
      this.isQuote = false
     }
    },
    'selectProductInfo.quantity': {
      deep: true,
      handler(newValue) {
        console.log(newValue , '没进去？？？');
        if (this.checkedAccident) {
          this.sumPremium = this.selectProductInfo.sumPremium
        }
      }
    },
    'selectProductInfo.insureGradeNo': {
      deep: true,
      handler(newValue) {
        if (this.checkedAccident) {
          this.isQuote = false
        }
      }
    }
  },
  mounted() {
    this.taxRelifInfo.lastCIPaymentTime = checkFormat.getTimeToDate(this.lastDate)
    // console.log(process.env.ENV_CONFIG, 'process.env.ENV_CONFIG')
    this.comName = localStorage.getItem('setMotorAreaName')
    if (this.comName === 'HU_NAN') {
      this.checkedAccident = false
    }
  },
  activated() {
    this.isRelif = false
    console.log(this.$store.state.motorBaseInfo.proposalCityCode, 'motorBaseInfo')
    this.$store.commit('set_motorStep', '3')
    this.$store.commit('set_showStep', true)
    this.isQuote = false
    // 陕西610000 河南410000 河北130000 福建350000 浙江330000/宁波330200
    console.log(this.comName, 'comName')

    console.log(this.proposalCityCode, 'this.proposalCityCode')
    // console.log(areaDetail, 'areaDetail')
    areaDetail.forEach(El => {
      if (El.comName === this.comName) {
        this.proposalAreaCode = El.comCode
      }
    })
    if (this.comName === 'NING_BO' || this.comName === 'XIA_MEN') {
      this.proposalCityCode = localStorage.getItem('proposalCityCode') || this.$store.state.motorBaseInfo.proposalCityCode
    } else {
      this.proposalCityCode = this.proposalAreaCode
    }
    console.log(this.proposalCityCode, 'this.proposalCityCode')
    if (this.comName !== 'HU_NAN') {
      this.getProductInfo()
    }
    this.queryDictionary()
    this.initDate()
    this.getYearList()
    this.taxRelifInfo.taxpayerIdentifier = JSON.parse(localStorage.getItem('cInfo')).identifyNum
    if (this.taxRelifInfo.payLastYear === '') {
      this.getYearList()
    }
    if (localStorage.getItem('cInfo')) {
      this.cInfo = JSON.parse(localStorage.getItem('cInfo'))
      this.cInfo.name = checkFormat.hideInsurantName(1, this.cInfo.name)
      this.cInfo.identifyNum = checkFormat.hideInsurantName(3, this.cInfo.identifyNum)
      setWaterMark(this.cInfo.name + '-' + this.cInfo.identifyNum)
    }
  },
  deactivated() {
    removeWatermark()
  },
  methods: {
    clearData() { // 车税切换清空
      // console.log(this.taxRelifInfo.freeRateText);
      // console.log(this.taxRelifInfo.relifReason);
      // console.log(this.taxRelifFlagName);
      // console.log(this.taxRelifInfo.relifReasonMain);
      // this.taxRelifInfo.taxpayerIdentifier = '';
      this.taxRelifInfo.extendChar2 = ''
      this.taxRelifInfo.taxRelief = ''
      // this.taxRelifInfo.freeRateText = ''
      this.relifReasonMainName = ''
      this.taxRelifInfo.paidFreeCertificate = ''
      // this.taxRelifInfo.taxDue = ''
      // console.log(this.isQuote, 'isQuote')
    },
    motorCodeCode(codeCode, type) {
      console.log(codeCode, 'codeCode')
      const upperCode = codeCode.slice(0, type)
      const param = [
        { codeType: 'MotoTaxRelifPlatformFlag', upperCode: upperCode }
      ] // 上平台车船税类型查询数据
      console.log(param, 'param')
      this.switchs = true
      this.$http.post(api.getByMoreCodeType, param)
        .then(res => {
          this.switchs = false
          if (res.data.rtnCode === '0000') {
            res.data.result.forEach(item => {
              if (item.codeType === 'MotoTaxRelifPlatformFlag' && item.upperCode === codeCode) {
                const taxObj = {
                  text: item.codecname,
                  code: item.codeCode
                }
                this.MotorcycleTaxRelifClounmNB.push(taxObj)
              }
            })
          }
          this.isRelif = true
          // console.log(this.MotorcycleTaxRelifClounmNB, 'this.MotorcycleTaxRelifClounmNB')
          const orderDetail = this.$store.state.motorOrderDetail
          // console.log(orderDetail, 'orderDetail=============');
          if (orderDetail && Object.keys(orderDetail).length > 0 && orderDetail.taxRelifInfo && Object.keys(orderDetail.taxRelifInfo).length > 0) {
            let find = ''
            if (orderDetail.taxRelifInfo.taxRelifFlag) {
              find = res.data.result.find(item => {
                return item.codeCode === orderDetail.taxRelifInfo.taxRelifFlag && item.codeType === 'MotoTaxRelifPlatformFlag'
              })
            }
            // console.log(find)
            this.taxRelifFlagName = find.codecname
          }
          if (this.MotorcycleTaxRelifClounmNB.length === 0 && type === 3) {
            this.motorCodeCode(codeCode, 5)
          } else {
            return false
          }
        })
        .catch(err => {
          this.switchs = false
          console.log(err)
        })
    },
    getProductInfo() {
      const baseInfo = this.$store.state.motorBaseInfo
      // const channelCode = sessionStorage.getItem('channelCode')
      const params = {
        businessNature: '2',// B端用户---channelCode, A端用户传1，其他端传2
        carKindCode: baseInfo.carKindCode, 
        comCode:this.$store.state.motorComCode,
        carRiskCode: '',
        seatCount: baseInfo.seatCount,
        useNature: baseInfo.useNatureCode,
        agentCode: '',
        noCarRiskCodeList: [],
        carRiskCodeList: ['0591']
      }
      this.$http.post(api.queryProductByCondition, params).then(res => {
        if (res.data.rtnCode === '0000') {
          this.isjiacheng = true
          this.productInfoList = res.data.productDtoList
          if (this.productInfoList.length > 0) {
            console.log(this.productInfoList[0], '-----');
            const orderDetail = this.$store.state.motorOrderDetail
            if ((orderDetail && !orderDetail.carPolicySubInfoList) || (orderDetail && orderDetail.carPolicySubInfoList && orderDetail.carPolicySubInfoList.length < 1)) {
              this.accidentKindInfo = this.productInfoList[0]
              this.selectProductInfo.sumAmount = this.accidentKindInfo.sumAmount
              this.selectProductInfo.sumPremium = this.accidentKindInfo.sumPremium
              this.selectRadio = this.accidentKindInfo.projectCode
              this.quantityColum = commonUtils.generateArray(this.accidentKindInfo.maxQuantity || 1)
              this.sumPremium = this.checkedAccident ? this.accidentKindInfo.sumPremium : '报价后可见'
            } else {
              console.log(this.productInfoList,this.accidentKindInfo, '0-0000000');
              const selectObj = this.productInfoList.filter(el => el.projectCode === this.accidentKindInfo.insureGradeNo)[0]
              console.log(selectObj, '选中的方案集合');
              this.quantityColum = commonUtils.generateArray(selectObj.maxQuantity || 1)
            }
          }
        } else {
          this.isjiacheng = false
          this.productInfoList = []
          this.selectProductInfo = {}
        }
      }).catch(err=>{
        console.log(err, 'queryProductByCondition')
      })
    },
     selectProduct(row) {
      if (row.projectCode !== this.selectRadio) {
        this.selectRadio = row.projectCode
      }
    },
    selectSure() {
      this.accidentKindInfo = this.productInfoList.filter(el => el.projectCode === this.selectRadio)[0]
      this.selectProductInfo.insureGradeNo = this.accidentKindInfo.projectCode
      this.quantityColum = commonUtils.generateArray(this.accidentKindInfo.maxQuantity || 1)
      this.selectProductInfo.quantity = '1'
      this.selectProductInfo.sumAmount = this.accidentKindInfo.sumAmount
      this.selectProductInfo.sumPremium = this.accidentKindInfo.sumPremium
      this.showProductDetail = false
    },
    cancelSelect() {
      this.showProductDetail = false
      this.selectRadio = this.accidentKindInfo.projectCode
    },
    queryDictionary() { // 数据字典
      this.MotorcycleTaxRelifClounm = []
      this.calculateModeCloumn = []
      this.motorcycleReasonsTax = []
      this.motorcycleRelifReason = []
      this.MotorcycleTaxRelifClounmNB = []
      this.TaxPaidAreaCodes = []
      const params = [
        { codeType: 'MotorcycleTaxRelifFlag' }, // 车船税
        { codeType: 'MotorcycleCalculateMode' }, // 计算类别
        { codeType: 'MotorcycleReasonsTax' }, // 减税原因
        { codeType: 'MotorcycleRelifReason' }, // 免征原因
        { codeType: 'TaxPaidAreaCode' }, // 上平台完税地区
        { codeType: 'RelifReason' }, // 上平台免征原因
        { codeType: 'motoCarShipSwitch' } // 是否上平台
      ]
      console.log(this.proposalCityCode, '上平台的城市')
      this.$http.post(api.getByMoreCodeType, params)
        .then(res => {
          if (res.data.rtnCode === '0000') {
            res.data.result.forEach(item => {
              if (item.codeType === 'MotorcycleTaxRelifFlag') {
                const taxObjs = {
                  text: item.codecname,
                  code: item.codeCode
                }
                this.MotorcycleTaxRelifClounm.push(taxObjs)
              }
              if (item.codeType === 'motoCarShipSwitch') {
                // console.log(item, '上平台的城市')
                console.log(item.codeCode.indexOf(this.proposalCityCode))
                if (item.codeCode.includes(this.proposalCityCode)) {
                  this.motorCodeCode(item.codeCode, 3)
                  this.isCarShipSwitch = true
                }
              }
              if (item.codeType === 'RelifReason') {
                // console.log(item, '00000000===RelifReason===?')
                const relifReasonNB = {
                  text: item.codecname,
                  code: item.codeCode
                }
                this.motorcycleRelifReasonNB.push(relifReasonNB)
              }
              if (item.codeType === 'MotorcycleCalculateMode') {
                const modelObj = {
                  text: item.codecname,
                  code: item.codeCode
                }
                this.calculateModeCloumn.push(modelObj)
              }
              if (item.codeType === 'MotorcycleReasonsTax') {
                const reasonTax = {
                  text: item.codecname,
                  code: item.codeCode
                }

                this.motorcycleReasonsTax.push(reasonTax)
              }

              if (item.codeType === 'MotorcycleRelifReason') {
                const relifReason = {
                  text: item.codecname,
                  code: item.codeCode
                }
                this.motorcycleRelifReason.push(relifReason)
              }
              if (item.codeType === 'TaxPaidAreaCode') {
                const taxPaidArea = {
                  text: item.codecname,
                  code: item.codeCode
                }
                this.TaxPaidAreaCodes.push(taxPaidArea)
                // console.log(this.TaxPaidAreaCode, '0998899-===')
              }
            })
          } else {
            this.$toast(res.data.rtnMsg)
          }
          console.log(res.data, '-009988888')
          const orderDetail = this.$store.state.motorOrderDetail
          console.log(orderDetail, 'orderDetail')
          // console.log(this.MotorcycleTaxRelifClounmNB, 'this.MotorcycleTaxRelifClounmNB')
          // console.log(orderDetail.taxRelifInfo.payLastYear, 'payLastYear')
          if (orderDetail && Object.keys(orderDetail).length > 0 && orderDetail.taxRelifInfo && Object.keys(orderDetail.taxRelifInfo).length > 0) {
            let find = ''
            let findRelifReason = ''
            let findTaxPaidArea = ''
            let findCalculateMode = ''
            let findRelifReasonJS = ''
            console.log(findRelifReasonJS, 'findRelifReasonJS')
            if (orderDetail.taxRelifInfo.calculateMode) {
              findCalculateMode = res.data.result.find(item => {
                return item.codeCode === orderDetail.taxRelifInfo.calculateMode && item.codeType === 'MotorcycleCalculateMode'
              })
            }
            if (orderDetail.taxRelifInfo.taxRelifFlag && !this.isCarShipSwitch) {
              find = res.data.result.find(item => {
                return item.codeCode === orderDetail.taxRelifInfo.taxRelifFlag && item.codeType === 'MotorcycleTaxRelifFlag'
              })
            }
            if (orderDetail.taxRelifInfo.relifReason) {
              findRelifReason = res.data.result.find(item => {
                return item.codeCode === orderDetail.taxRelifInfo.relifReason && item.codeType === 'RelifReason'
              })
              findRelifReasonJS = res.data.result.find(item => {
                return item.codeCode === orderDetail.taxRelifInfo.relifReason && item.codeType === 'MotorcycleReasonsTax'
              })
            }
            if (orderDetail.taxRelifInfo.taxPaidAreaCode) {
              findTaxPaidArea = res.data.result.find(item => {
                return item.codeCode === orderDetail.taxRelifInfo.taxPaidAreaCode && item.codeType === 'TaxPaidAreaCode'
              })
            }
            console.log(findRelifReasonJS, 'findRelifReasonJS')
            // console.log(findRelifReason.codecname, 'findRelifReason')
            console.log(find)
            this.taxRelifFlagName = find.codecname
            // console.log(this.isCarShipSwitch, 'isCarShipSwitch')
            if (this.isCarShipSwitch) {
              this.relifReasonMainName = findRelifReason ? findRelifReason.codecname : ''
            } else {
              this.relifReasonMainName = findRelifReasonJS ? findRelifReasonJS.codecname : ''
            }
            this.relifReasonName = findRelifReasonJS ? findRelifReasonJS.codecname : ''
            this.TaxPaidAreaName = findTaxPaidArea.codecname
            this.calculateModeName = findCalculateMode.codecname
            if (find.codeCode === '2') {
              this.freeRateTextList = [{
                code: 'E',
                text: '免税'
              }]
            }
            // else if (find.codeCode === '3') {
            //   this.freeRateTextList = [{
            //     code: 'P',
            //     text: '比例减免'
            //   }]
            // }
            this.freeRateTextName = '免税'
          }
        })
        .catch(error => {
          this.add = this.add - 1
          console.log(error)
        })
    },
    confirm(value, type) {
      this.isQuote = false
      console.log(type, value.text, value, '===type')
      if (type === 'taxRelif') {
        this.taxRelifInfo.taxRelifFlag = value.code
        this.taxRelifFlagName = value.text
        this.showTaxRelif = false
        if (value.code === '2') {
          this.freeRateTextList = [{
            code: 'E',
            text: '免税'
          }]
        }
        // if (value.code === '5') {
        //   this.freeRateTextList = [{
        //     code: '1',
        //     text: '正常缴税'
        //   }]
        // }
        this.clearData()
      }
      if (type === 'calculateMode') {
        this.taxRelifInfo.calculateMode = value.code
        this.calculateModeName = value.text
        this.showCalculateMode = false
      }
      if (type === 'year') {
        this.taxRelifInfo.payLastYear = value.code
        this.showYear = false
      }
      if (type === 'reasonTax') {
        this.taxRelifInfo.relifReason = value.code
        this.relifReasonName = value.text
        this.showReasonTax = false
        console.log(this.relifReasonName, this.taxRelifInfo.relifReason, '6666')
      }
      if (type === 'reasonMain') {
        this.taxRelifInfo.relifReasonMain = value.code
        this.relifReasonMainName = value.text
        this.showReasonMain = false
        console.log(this.relifReasonMainName, this.taxRelifInfo.relifReasonMain, '55555')
        this.isQuote = false
      }
      if (type === 'TaxPaidShow') {
        // TaxPaidAreaName
        this.taxRelifInfo.taxPaidAreaCode = value.code
        this.TaxPaidAreaName = value.text
        this.showTaxPaidCode = false
      }
      if (type === 'freeRateText') {
        // TaxPaidAreaName
        this.taxRelifInfo.freeRateText = value.code
        console.log(this.taxRelifInfo.freeRateText, '===-----')
        this.freeRateTextName = value.text
        this.showFreeRateText = false
      }
      if (type === 'quantity') {
        this.selectProductInfo.quantity = value
        this.selectProductInfo.sumAmount = this.accidentKindInfo.sumAmount * value
        this.selectProductInfo.sumPremium = this.accidentKindInfo.sumPremium * value
        this.showQuantity = false
      }
      // console.log(this.isQuote, '报价不')
    },
    initDate() { // 交强险起期默认为第二天00时、止期默认为第二年的当前天的24时
      console.log(this.$store.state.motorOrderDetail, '摩托车订单详情')
      console.log(this.taxRelifInfo.taxRelifFlag, '09999')
      const date = this.$moment(new Date().getTime()).add(1, 'd')
      const year = new Date(date).getFullYear
      const month = this.filtration(new Date(date).getMonth())
      const daa = this.filtration(new Date(date).getDate())
      // const add = new Date() * 1 + 60 * 60 * 1000
      const add = new Date()
      this.minDate = new Date(add)
      console.log(date, year, month, daa)
      this.currentDate = new Date(year, month, daa)
      this.startDateCI = this.$moment(new Date().getTime()).add(1, 'd').format('YYYY-MM-DD')
      const jqday = this.$moment(this.startDateCI).subtract(1, 'd').format('YYYY-MM-DD')
      this.endDateCI = this.$moment(jqday).add(1, 'years').format('YYYY-MM-DD')
      const orderDetail = this.$store.state.motorOrderDetail
      if (orderDetail && Object.keys(orderDetail).length > 0 && orderDetail.taxRelifInfo && Object.keys(orderDetail.taxRelifInfo).length > 0) {
        // console.log('进入暂存')
        if (orderDetail.insuredList && orderDetail.insuredList.length > 0) {
          orderDetail.insuredList.forEach(item => {
            if (item.insuredRelationship !== '3' || item.insuredRelationship !== '4') {
              // console.log(item.identifyNumber, 'item.identifyNumber')
              this.taxRelifInfo.taxpayerIdentifier = item.identifyNumber
              // console.log(this.taxRelifInfo.taxpayerIdentifier, 'item.taxpayerIdentifier')
            }
          })
        }
        this.sumPremium = orderDetail.orderAmount
        this.taxRelifInfo = orderDetail.taxRelifInfo || {}
        console.log(orderDetail.taxRelifInfo, '=======>')
        console.log(this.taxRelifInfo.relifReason, '===relifReasonMain====>')
        if (this.taxRelifInfo.taxRelifFlag === '2') {
          this.taxRelifInfo.relifReasonMain = orderDetail.taxRelifInfo.relifReason
          this.taxRelifInfo.paidFreeCertificate = orderDetail.taxRelifInfo.extendChar2
        } else if (this.taxRelifInfo.taxRelifFlag === '3') {
          this.taxRelifInfo.relifReason = orderDetail.taxRelifInfo.relifReason
        } else if (this.taxRelifInfo.taxRelifFlag === '4') {
          this.taxRelifInfo.paidFreeCertificate = orderDetail.taxRelifInfo.paidFreeCertificate
        }
        // this.taxRelifInfo.relifReason = orderDetail.taxRelifInfo.relifReason
        if (orderDetail.baseInfo !== null && Object.keys(orderDetail.baseInfo).length > 0) {
          this.sumPremiumCI = orderDetail.baseInfo.sumPremiumCI
          if (orderDetail.baseInfo.startDateCI) {
            const baseInfo = orderDetail.baseInfo
            this.startDateCI = baseInfo.startDateCI
            this.startHourCI = baseInfo.startHourCI
            this.startMinuteCI = baseInfo.startMinuteCI
            this.endDateCI = baseInfo.endDateCI
            this.endHourCI = baseInfo.endHourCI
            this.endMinuteCI = baseInfo.endMinuteCI
          } else {
            // const date = this.$moment(new Date().getTime()).add(1, 'd')
            // const year = new Date(date).getFullYear
            // const month = this.filtration(new Date(date).getMonth())
            // const daa = this.filtration(new Date(date).getDate())
            // // const add = new Date() * 1 + 60 * 60 * 1000
            // const add = new Date()
            // this.minDate = new Date(add)
            // console.log(date, year, month, daa)
            // this.currentDate = new Date(year, month, daa)
            // this.startDateCI = this.$moment(new Date().getTime()).add(1, 'd').format('YYYY-MM-DD')
            // const jqday = this.$moment(this.startDateCI).subtract(1, 'd').format('YYYY-MM-DD')
            // this.endDateCI = this.$moment(jqday).add(1, 'years').format('YYYY-MM-DD')
          }
        }
        console.log(orderDetail, 'meinadaoma1');
        if (orderDetail.carPolicySubInfoList && orderDetail.carPolicySubInfoList.length > 0) {
            this.accidentKindInfo = orderDetail.carPolicySubInfoList[0]
            this.accidentKindInfo.projectName = this.accidentKindInfo.riskName
            this.accidentKindInfo.projectCode = this.accidentKindInfo.insureGradeNo
            this.selectProductInfo.sumAmount = this.accidentKindInfo.sumAmount
            this.selectProductInfo.sumPremium = this.accidentKindInfo.sumPremium
            this.selectRadio = this.accidentKindInfo.insureGradeNo
            this.selectProductInfo.insureGradeNo = this.accidentKindInfo.insureGradeNo
            this.selectProductInfo.riskCode = this.accidentKindInfo.riskCode
            this.selectProductInfo.riskName = this.accidentKindInfo.riskName
            this.selectProductInfo.quantity = this.accidentKindInfo.quantity
            console.log(this.selectRadio, '选中方案');
            // this.quantityColum = commonUtils.generateArray(this.accidentKindInfo.maxQuantity || 1)
        }
      }
      // console.log(this.startDateCI, 'initDate')
      this.realValue(this.startDateCI)
      // console.log(this.taxRelifInfo.taxRelifFlag, 'taxRelifInfo.taxRelifFlag')
    },
    getYearList(val = 2001) {
      // 获取指定年份开始到现在年份的数组
      const timeList = []
      const smallYears = val
      const date = new Date() // 获取当前时间
      let NowYears = date.getFullYear()
      var Years = NowYears - smallYears
      const arrTim = []
      for (let index = 0; index <= Years; index++) {
        arrTim.push(NowYears--)
      }
      arrTim.forEach((tim) => {
        timeList.push(tim)
      })
      const orderDetail = this.$store.state.motorOrderDetail
      // this.taxRelifInfo.payLastYear = timeList[1]
      if (orderDetail && Object.keys(orderDetail).length > 0 && orderDetail.taxRelifInfo && Object.keys(orderDetail.taxRelifInfo).length > 0 && orderDetail.taxRelifInfo.payLastYear) {
        this.taxRelifInfo.payLastYear = orderDetail.taxRelifInfo.payLastYear
      } else {
        this.taxRelifInfo.payLastYear = timeList[1]
      }
      for (let i = 0; i < timeList.length; i++) {
        this.yearOption.push({
          code: timeList[i],
          text: timeList[i]
        })
      }
    },
    lastTimeSure(value) {
      this.taxRelifInfo.lastCIPaymentTime = checkFormat.getTimeToDate(value)
      this.lastTimeVisible = false
    },
    taxDocumentTimeSure(value) {
      this.taxRelifInfo.taxDocumentDate = checkFormat.getTimeToDate(value)
      this.taxTimeVisible = false
    },
    filtration(value) {
      return value < 10 ? '0' + value : value
    },
    openStartDate() {
      this.popupTimeVisible = true
    },
    textCodeInput(value) { // 开具税务机关代码
      console.log(value, '----')
      this.isQuote = false
    },
    taxComNameInput(value) { // 开具税务机关代码
      console.log(value, '----')
      this.isQuote = false
    },
    freeRateTextInput(value) { // 开具税务机关代码
      console.log(value, '----')
      this.isQuote = false
    },
    extendCharInput(value) { // 免税凭证号
      console.log(value, '--extendChar2Input--')
      this.isQuote = false
    },
    sureHour(value) {
      this.isQuote = false
      const now = new Date(value)
      const year = now.getFullYear() + 1
      const month = this.filtration(now.getMonth() + 1)
      const daa = this.filtration(now.getDate())
      const hour = this.filtration(now.getHours())
      this.startDateCI = now.getFullYear() + '-' + month + '-' + daa
      this.startHourCI = hour
      this.startMinuteCI = this.filtration(now.getMinutes())
      const timejq = new Date(now * 1 - 24 * 60 * 60 * 1000)
      if (hour === '00' && this.startMinuteCI === '00') {
        if (now.getFullYear() % 4 === 0 && month === '03' && String(daa) === '01') {
          this.endDateCI = year + '-' + '02' + '-' + '28'
        } else if (now.getFullYear() % 4 === 3 && month === '03' && String(daa) === '01') {
          this.endDateCI = year + '-' + '02' + '-' + '29'
        } else {
          this.endDateCI = timejq.getFullYear() + 1 + '-' + this.filtration(timejq.getMonth() + 1) + '-' + this.filtration(timejq.getDate())
        }
        this.endHourCI = '24'
        this.endMinuteCI = '00'
      } else {
        if (now.getFullYear() % 4 === 0 && month === '02' && String(daa) === '29') {
          this.endDateCI = year + '-' + '02' + '-' + '28'
        } else {
          this.endDateCI = now.getFullYear() + 1 + '-' + this.filtration(now.getMonth() + 1) + '-' + this.filtration(now.getDate())
        }
        // this.endHourCI = '24'
        // this.endMinuteCI = '00'
        this.endHourCI = this.filtration(now.getHours())
        this.endMinuteCI = this.filtration(now.getMinutes())
      }
      const time = new Date() * 1
      const times = now * 1
      if (times - time <= 15 * 60 * 1000) {
        this.$toast('您选择的起保时间即将生效，请尽快完成。')
      }
      this.popupTimeVisible = false
      console.log(this.startDateCI, '调用')
      this.realValue(this.startDateCI)
    },
    realValue(day) {
      const baseInfo = this.$store.state.motorBaseInfo
      // console.log(baseInfo, 'baseInfo')
      const dataVal = {
        enrollDate: baseInfo.enrollDate, // 车辆初始登记日期
        purchasePrice: baseInfo.purchasePrice, // 新车购置价
        updateEnrollDate: baseInfo.updateEnrollDate, // 初等日期调整
        seatCount: baseInfo.seatCount, // 座位数
        tonCount: baseInfo.tonCount, // 吨数
        carKindCode: baseInfo.carKindCode, // 车辆种类代码
        useNatureCode: '87', // 使用性质
        startDate: day
      }
      this.$http.post(api.getActualValue, dataVal).then(resAct => {
        if (resAct.data.rtnCode === '0000') {
          baseInfo.actualValue = resAct.data.actualValue + ''
          baseInfo.agreeActualValue = resAct.data.actualValue + ''
        } else {
          this.$toast(resAct.data.rtnMsg)
        }
      }).catch(err => {
        console.log(err, 'getActualValue')
      })
    },
    toQuote() {
      // console.log(this.taxRelifFlagName, '==taxRelifFlagName=====')
      // console.log(this.taxRelifInfo.relifReasonMain, '===relifReasonMain====')
      // console.log('进入')
      if (['正常缴税', '减税', '免税'].includes(this.taxRelifFlagName)) {
        if (!this.taxRelifInfo.taxpayerIdentifier) {
          this.$toast('请填写纳税人识别号')
          return false
        }
      }
      if (['减税', '免税'].includes(this.taxRelifFlagName)) {
        if (!this.taxRelifInfo.extendChar2) {
          this.$toast('请填写凭证号')
          return false
        }
      }
      if (this.taxRelifFlagName === '减税') {
        if (!this.taxRelifInfo.taxRelief) {
          this.$toast('请填写减免税额')
          return false
        }
        if (!this.taxRelifInfo.freeRateText) {
          this.$toast('请填写减免说明')
          return false
        }
        if (!this.relifReasonName) {
          this.$toast('请选择减税原因')
          return false
        }
      } else if (this.taxRelifFlagName === '免税') {
        if (!this.relifReasonMainName) {
          this.$toast('请选择免征原因')
          return false
        }
      } else if (this.taxRelifFlagName === '完税') {
        if (!this.taxRelifInfo.paidFreeCertificate) {
          this.$toast('请填写完税凭证号')
          return false
        }
      }
      if (['1','2','3'].includes(this.taxRelifInfo.taxRelifFlag) && !this.isCarShipSwitch) {
        if (!checkFormat.isCardNo(this.taxRelifInfo.taxpayerIdentifier)) {
          this.$toast('请填写正确的纳税人识别号')
          return
        }
      }
      if (this.isVehicle) {
        if (!this.veCode && this.veImg) {
          this.$toast('请输入商业险查询校验码')
            return false
        }
        if (!this.veCodeCI && this.veImgCI) {
          this.$toast('请输入交强险查询校验码')
          return false
        }
      }
      console.log(this.taxRelifInfo.taxpayerIdentifier, '纳税号')
      const baseInfo = this.$store.state.motorBaseInfo
      if (this.accidentKindInfo && Object.keys(this.accidentKindInfo).length > 0) {
        this.selectProductInfo.insureGradeNo = this.accidentKindInfo.projectCode
        this.selectProductInfo.riskCode = this.accidentKindInfo.riskCode
        this.selectProductInfo.riskName = this.accidentKindInfo.riskName
        this.selectProductInfo.productCode = null
        this.selectProductInfo.productName = this.accidentKindInfo.projectName
        this.selectProductInfo.isUselnsured = null
        this.selectProductInfo.actualPremium = null
        this.selectProductInfo.commi = null
        this.selectProductInfo.planName = this.accidentKindInfo.projectName
        // this.selectProductInfo.maxQuantity = this.accidentKindInfo.maxQuantity
      }
      console.log(this.selectProductInfo, 'this.selectProductInfo')
      const params = {
        agentCode: '',
        deletedFlag: '', // 删除状态（传Y删除）
        orderId: this.$store.state.motorOrderId,
        orderNo: this.$store.state.motorOrderDetail.orderNo || this.$store.state.orderNo,
        orderOrigin: 'DP_OWXPA',
        planName: '',
        productCode: 'motor_product',
        productName: '摩托车险',
        orderAmount: this.sumPremium === '报价后可见' ? '' : this.sumPremium, // 总保费
        cHandleFee: this.cHandleFee === '报价后可见' ? '' : this.cHandleFee, // 手续费
        handlingFeeFlag: '', // 0--不需要计算手续费  1/空---需要计算手续费
        insuranceSign: '0', // 0--车险 1--非车险
        proposalAreaCode: this.proposalAreaCode,
        proposalCityCode: baseInfo.proposalCityCode,
        terminalId: 'H5',
        terminalIdType: '',
        // comCode: process.env.ENV_CONFIG === 'dev' ? '2410100601' : '2410102606',
        baseInfo: {
          channelCode: 'DP_OWXPA',
          // businessNature: '0',
          // comCode: process.env.ENV_CONFIG === 'dev' ? '2410100601' : '2410102606',
          // handler1Code: process.env.ENV_CONFIG === 'dev' ? '241003245' : '241013036',
          // operatorCode: process.env.ENV_CONFIG === 'dev' ? '241003245' : '241013036',
          calculateFlag: '2', // 是否关联单标识(1-只计算商业险保费；2-计算交强险保费和车船税)
          startDateCI: this.startDateCI,
          endDateCI: this.endDateCI,
          startHourCI: this.startHourCI,
          startMinuteCI: this.startMinuteCI,
          endHourCI: this.endHourCI,
          endMinuteCI: this.endMinuteCI,
          sumAmount: '', // 总保额
          sumPremiumCI: this.sumPremiumCI === '报价后可见' ? '' : this.sumPremiumCI, // 交强险总保费
          answer:this.veCode, // 转保业务第二次交互时必传（商业险）
          demandNo:this.demandNo || '', // 如果是转保业务，第二次交互时必传。取返回图片校验码那次的demandNo（商业险）
          demandNoCI:this.demandNoCI || '', // 如果是转保业务，第二次交互时必传。取返回图片校验码那次的demandNoCI（交强险）
          answerCI:this.veCodeCI, // 转保业务第二次交互时必传（交强险）
        },
        taxRelifInfo: {
          taxComCode: this.taxRelifInfo.taxComCode,
          taxComName: this.taxRelifInfo.taxComName,
          taxRelifFlag: this.taxRelifInfo.taxRelifFlag,
          calculateMode: this.taxRelifInfo.calculateMode,
          payLastYear: this.taxRelifInfo.payLastYear,
          lastCIPaymentTime: this.taxRelifInfo.lastCIPaymentTime,
          taxDocumentDate: this.taxRelifFlagName === '完税' ? this.taxRelifInfo.taxDocumentDate : '',
          taxPaidAreaCode: this.taxRelifFlagName === '完税' ? this.taxRelifInfo.taxPaidAreaCode : '',
          taxActual: this.taxRelifInfo.taxActual === '报价后可见' ? '' : this.taxRelifInfo.taxActual,
          previousPay: this.taxRelifInfo.previousPay === '报价后可见' ? '' : this.taxRelifInfo.previousPay,
          lateFee: this.taxRelifInfo.lateFee === '报价后可见' ? '' : this.taxRelifInfo.lateFee,
          sumPayTax: this.taxRelifInfo.sumPayTax === '报价后可见' ? '0.0' : this.taxRelifInfo.sumPayTax,
          taxDue: this.taxRelifInfo.taxDue === '报价后可见' ? '' : this.taxRelifInfo.taxDue,
          paidFreeCertificate: this.taxRelifFlagName === '完税' ? this.taxRelifInfo.paidFreeCertificate : this.taxRelifInfo.extendChar2, // 减免税凭证号
          // identifyNumber:this.taxRelifInfo.taxpayerIdentifier,//纳税人识别号
          taxRelief: this.taxRelifInfo.taxRelief, // 减免比例/减免金额
          // this.taxRelifInfo.freeRateText
          freeRateText: this.taxRelifInfo.freeRateText, // 减免说明
          // extendChar2: this.taxRelifInfo.extendChar2,
          relifReason: this.taxRelifFlagName === '免税' ? this.taxRelifInfo.relifReasonMain : this.taxRelifInfo.relifReason, // 减免税原因
          taxpayerIdentifier: this.$store.state.carOwnerInfo.ownerIdentifyType// 纳税人证件类型/摩托车里叫纳税人识别号
        },
        vehicleInfo: baseInfo,
        carOwnerInfo: this.$store.state.carOwnerInfo, // 车主信息
        insuredList: this.$store.state.insuredList,
        itemKindList: itemKindList,
        itemFileDataList: this.$store.state.itemFileDataList,
      }
      let selectProductInfo = Object.keys(this.selectProductInfo).length > 0 ? [this.selectProductInfo] : []
      params.carPolicySubInfoList = this.checkedAccident ? selectProductInfo : []
      console.log(params, '000999898888888')
      if (this.taxRelifFlagName === '免税') {
        params.taxRelifInfo.paidFreeCertificate = ''
      }
      if (this.isCarShipSwitch) {
        params.taxRelifInfo.extendChar2 = this.taxRelifInfo.extendChar2
      }
      if (this.MotorcycleTaxRelifClounmNB && this.MotorcycleTaxRelifClounmNB.length > 0 && this.isRelif) {
        params.taxRelifInfo.sumPayTax = this.taxRelifInfo.sumPayTax === '报价后可见' ? null : this.taxRelifInfo.sumPayTax
        params.taxRelifInfo.taxRelifFlag = this.taxRelifInfo.taxRelifFlag
        params.taxRelifInfo.taxComCode = ''
        params.taxRelifInfo.taxComName = ''
        params.taxRelifInfo.calculateMode = ''
        params.taxRelifInfo.payLastYear = ''
        params.taxRelifInfo.lastCIPaymentTime = ''
        params.taxRelifInfo.taxActual = ''
        params.taxRelifInfo.previousPay = ''
        params.taxRelifInfo.lateFee = ''
        params.taxRelifInfo.taxDue = ''
        params.taxRelifInfo.taxRelief = ''
        // params.taxRelifInfo.taxpayerIdentifier = ''
        params.taxRelifInfo.freeRateText = ''
        params.taxRelifInfo.relifReason = ''
        if (this.taxRelifInfo.taxRelifFlag === '2') { // 免税
          params.taxRelifInfo.paidFreeCertificate = ''
          params.taxRelifInfo.relifReason = this.taxRelifInfo.relifReasonMain
          params.taxRelifInfo.taxComCode = this.taxRelifInfo.taxComCode
          params.taxRelifInfo.taxComName = this.taxRelifInfo.taxComName
          params.taxRelifInfo.freeRateText = 'E'
        } else if (this.taxRelifInfo.taxRelifFlag === '4') { // 完税
          params.taxRelifInfo.taxComCode = this.taxRelifInfo.taxComCode
          params.taxRelifInfo.taxComName = this.taxRelifInfo.taxComName
          params.taxRelifInfo.paidFreeCertificate = this.taxRelifFlagName === '完税' ? this.taxRelifInfo.paidFreeCertificate : ''
          params.taxRelifInfo.taxDocumentDate = this.taxRelifFlagName === '完税' ? this.taxRelifInfo.taxDocumentDate : ''
          params.taxRelifInfo.taxPaidAreaCode = this.taxRelifFlagName === '完税' ? this.taxRelifInfo.taxPaidAreaCode : ''
        }
      }
      this.switchs = true
      this.$http.post(api.calculateFeeForMotor, params)
        .then(res => {
          this.switchs = false
          console.log(res.data, '=====反参')
          if (res.data.rtnCode === '0000') {
            this.sumPremium = res.data.basePart.sumPremium
            if (res.data.itemKindList && res.data.itemKindList.length > 0) {
              this.itemKindList = res.data.itemKindList
            }
            res.data.planList.forEach(item => {
              if (item.riskCode === '0591') {
                this.sumPremiumCI = item.planFee
              }
            })
            if (this.isQuote) {
              params.baseInfo.sumPremiumCI = this.sumPremiumCI
            }

            this.taxRelifInfo.taxActual = res.data.carShipTax.taxActual
            this.taxRelifInfo.previousPay = res.data.carShipTax.previousPay
            this.taxRelifInfo.lateFee = res.data.carShipTax.lateFee
            this.taxRelifInfo.sumPayTax = res.data.carShipTax.sumPayTax
            this.taxRelifInfo.taxDue = res.data.carShipTax.taxDue
            this.taxRelifInfo.sumPremium = this.sumPremium
            this.taxRelifInfo.taxpayerIdentifier = res.data.carShipTax.payerCode ? res.data.carShipTax.payerCode : this.taxRelifInfo.taxpayerIdentifier
            // console.log(this.MotorcycleTaxRelifClounmNB, 'motorcycleRelifReasonNB')
            // console.log(res.data.carShipTax.taxRelifFlag, 'res.data.carShipTax.taxRelifFlag')
            if (res.data.carShipTax.taxRelifFlag) {
              if (this.MotorcycleTaxRelifClounmNB && this.MotorcycleTaxRelifClounmNB.length > 0) {
                this.MotorcycleTaxRelifClounmNB.forEach(item => {
                  if (item.code === res.data.carShipTax.taxRelifFlag) {
                    this.taxRelifInfo.taxRelifFlag = item.code
                    this.taxRelifFlagName = item.text
                  }
                })
              }
            }
            // console.log(this.$store.state.motorOrderDetail)
            const orderDetail = this.$store.state.motorOrderDetail
            if (orderDetail && Object.keys(orderDetail).length > 0 && orderDetail.taxRelifInfo && Object.keys(orderDetail.taxRelifInfo).length > 0) {
              orderDetail.taxRelifInfo.taxActual = this.taxRelifInfo.taxActual
              orderDetail.taxRelifInfo.taxComCode = params.taxRelifInfo.taxComCode
              orderDetail.taxRelifInfo.taxComName = params.taxRelifInfo.taxComName
              orderDetail.taxRelifInfo.taxDocumentDate = params.taxRelifInfo.taxDocumentDate
              orderDetail.taxRelifInfo.previousPay = this.taxRelifInfo.previousPay
              orderDetail.taxRelifInfo.taxRelief = params.taxRelifInfo.taxRelief
              orderDetail.taxRelifInfo.taxPaidAreaCode = params.taxRelifInfo.taxPaidAreaCode
              orderDetail.taxRelifInfo.lateFee = this.taxRelifInfo.lateFee
              orderDetail.taxRelifInfo.sumPayTax = res.data.carShipTax.sumPayTax
              orderDetail.taxRelifInfo.taxDue = this.taxRelifInfo.taxDue
              orderDetail.taxRelifInfo.sumPremium = this.taxRelifInfo.sumPremium
              orderDetail.taxRelifInfo.extendChar2 = params.taxRelifInfo.extendChar2
              orderDetail.taxRelifInfo.freeRateText = params.taxRelifInfo.freeRateText
              orderDetail.taxRelifInfo.relifReason = params.taxRelifInfo.relifReason
              orderDetail.taxRelifInfo.calculateMode = params.taxRelifInfo.calculateMode
              orderDetail.taxRelifInfo.paidFreeCertificate = params.taxRelifInfo.paidFreeCertificate
              orderDetail.taxRelifInfo.payLastYear = params.taxRelifInfo.payLastYear
              orderDetail.taxRelifInfo.lastCIPaymentTime = params.taxRelifInfo.lastCIPaymentTime
              orderDetail.taxRelifInfo.taxpayerIdentifier = this.taxRelifInfo.taxpayerIdentifier
              orderDetail.taxRelifInfo.taxRelifFlag = params.taxRelifInfo.taxRelifFlag
              orderDetail.baseInfo.startDateCI = this.startDateCI
              orderDetail.baseInfo.startHourCI = this.startHourCI
              orderDetail.baseInfo.startMinuteCI = this.startMinuteCI
              orderDetail.baseInfo.endDateCI = this.endDateCI
              orderDetail.baseInfo.endHourCI = this.endHourCI
              orderDetail.baseInfo.endMinuteCI = this.endMinuteCI
              orderDetail.baseInfo.sumPremiumCI = this.sumPremiumCI
              orderDetail.baseInfo.sumAmount = this.sumAmount
              orderDetail.carPolicySubInfoList = params.carPolicySubInfoList
              orderDetail.orderAmount = this.sumPremium
              this.$store.commit('set_motorOrderDetail', orderDetail)
            }
            this.$store.commit('set_motorTaxRelifInfo', this.taxRelifInfo)
            console.log(orderDetail, 'params.orderDetail')
            this.$store.commit('set_motorBaseInfo', params.vehicleInfo)
            this.veCodeCI = ''
            this.veCode = ''
            this.isVehicle = false
            this.isQuote = true
          } else if (res.data.rtnCode === '9980') {
            if (res.data.basePart.question && res.data.basePart.renewalFlag === '1') {//商业险转保
              this.veImg = 'data:image/png;base64,' + res.data.basePart.question
              this.demandNo = res.data.basePart.demandNo
            }
            if (res.data.basePart.questionCI && res.data.basePart.renewalFlagCI === '1') { //交强险转保
              this.veImgCI = 'data:image/png;base64,' + res.data.basePart.question
              this.demandNoCI = res.data.basePart.demandNoCI
            }
            if ((res.data.basePart.question && res.data.basePart.renewalFlag === '1') || (res.data.basePart.questionCI && res.data.basePart.renewalFlagCI === '1') || (res.data.basePart.question && res.data.basePart.renewalFlag === '1' && res.data.basePart.renewalFlagCI === '1')) {
              this.isVehicle = true
              this.basePartList = res.data.basePart
              this.basePartFun(res.data.basePart)
            }
          } else if (res.data.rtnCode === '999') {
            this.$toast(res.data.rtnMsg)
            this.isVehicle = false
            this.veCodeCI = ''
            this.veCode = ''
            this.isQuote = false
            this.switchs = false
          } else{
            this.$toast(res.data.rtnMsg)
            this.isQuote = false
            this.switchs = false
          }
          console.log(this.isQuote, '报价接口')
        })
        .catch(err => {
          console.log(err)
          this.switchs = false
          this.isQuote = false
        })
    },
    veCancal(){
      this.isVehicle = false
      this.veCodeCI = ''
      this.veCode = ''
    },
    basePartFun(resList) {
      console.log(resList, '??')
      let data = [{
        base64: resList.questionCI || '',
        serialNo: resList.demandNoCI || '',
      },
      {
        base64: resList.question || '',
        serialNo: resList.demandNo || ''
      }]
      if (!this.veCode || !this.veCodeCI) {
        this.getVehicle(data)
      }
    },
    getVehicle(params) {
      this.switchs = true
      this.$http.post(api.vehicleCaptcha, params).then(res=>{
        this.switchs = false
        if (res.data.rtnCode === '0000') {
          if (res.data.results && res.data.results.length > 0){
            res.data.results.forEach(item => {
              if (item.serialNo === this.demandNo) {
                this.veCode = item.result
              } else {
                this.veCodeCI = item.result
              }
            })
          }
        } else {
          this.$toast(res.data.rtnMsg)
        }
      }).catch(err=>{
        this.switchs = false
        console.log(err, 'vehicleCaptcha')
      })
    },
    // 身份证校验
    checkIdentityNumber(IdentityNumber, judge) {
      console.log(IdentityNumber, 'IdentityNumber')
      if (judge) {
        if (checkFormat.isCardNo(IdentityNumber) === false) {
          this.$toast('请检查纳税人识别号：“ ' + IdentityNumber + '” 是否正确')
          return false
        } else {
          return true
        }
      }
    },
    goNext(type) {
      if (type === 'order') {
        // this.isQuote = true
        this.$router.push('/motor/orderList')
      } else {
        // console.log(this.taxRelifFlagName, '==taxRelifFlagName=====')
        // console.log(this.taxRelifInfo.relifReasonMain, '===relifReasonMain====')
        console.log(this.isQuote, '========')
        console.log(type, '===typetypetypetype=====')
        // console.log(this.sumPremiumCI, '??????')
        // console.log(this.$store.state.motorOrderId, 'this.$store.state.motorOrderId')
        // console.log(this.$store.state.motormotorBaseInfo, 'set_motormotorBaseInfo')
        const baseInfo = {
          channelCode: 'DP_OWXPA',
          // businessNature: '0',
          // comCode: process.env.ENV_CONFIG === 'dev' ? '2410100601' : '2410102606',
          // handler1Code: process.env.ENV_CONFIG === 'dev' ? '241003245' : '241013036',
          // operatorCode: process.env.ENV_CONFIG === 'dev' ? '241003245' : '241013036',
          calculateFlag: '2', // 是否关联单标识(1-只计算商业险保费；2-计算交强险保费和车船税)
          startDateCI: this.startDateCI,
          endDateCI: this.endDateCI,
          startHourCI: this.startHourCI,
          startMinuteCI: this.startMinuteCI,
          endHourCI: this.endHourCI,
          endMinuteCI: this.endMinuteCI,
          sumAmount: '', // 总保额
          sumPremiumCI: this.sumPremiumCI
        }
        this.taxRelifInfo.relifReason = this.taxRelifFlagName === '免税' ? this.taxRelifInfo.relifReasonMain : this.taxRelifInfo.relifReason // 减免税原因
        this.taxRelifInfo.paidFreeCertificate = this.taxRelifFlagName === '完税' ? this.taxRelifInfo.paidFreeCertificate : this.taxRelifInfo.extendChar2 // 减免税凭证号
        this.taxRelifInfo.taxpayerIdentifier = this.$store.state.carOwnerInfo.ownerIdentifyType
        let selectProductInfo = Object.keys(this.selectProductInfo).length > 0 ? [this.selectProductInfo] : []
        const params = {
          carOwnerInfo: this.$store.state.carOwnerInfo, // 车主信息
          vehicleInfo: this.$store.state.motorBaseInfo, // 车辆信息
          orderId: this.$store.state.motorOrderId, // 订单id
          taxRelifInfo: this.taxRelifInfo,
          terminalId: 'H5',
          orderOrigin: 'DP_OWXPA',
          channelCode: 'DP_OWXPA',
          productCode: 'motor_product',
          productName: '摩托车险',
          insuredList: this.$store.state.insuredList,
          baseInfo: baseInfo,
          itemKindList: this.itemKindList,
          itemFileDataList: this.$store.state.itemFileDataList,
          carPolicySubInfoList: this.checkedAccident ? selectProductInfo : []
        }
        console.log(params, '00999988888888')
        this.$store.commit('set_motormotorBaseInfo', baseInfo)
        console.log(this.isQuote, '下一步')
        // this.isQuote = type === 'order'
        // console.log(params, 'sumPremiumCI')
        // console.log(this.isQuote, 'this.isQuote')
        // console.log(this.$store.state.motorBaseInfo, 'this.$store.state.motorBaseInfo')
        // console.log(this.$store.state.motormotorBaseInfo, 'this.$store.state.motormotorBaseInfo')
        if (this.isQuote) {
          this.switchs = true
          this.$http.post(api.motorSava, params)
            .then(res => {
              this.switchs = false
              if (res.data.rtnCode === '0000') {
                this.$store.commit('set_motorStep', '4')
              } else {
                this.$toast(res.data.rtnMsg)
              }
              this.switchs = false
            })
            .catch(err => {
              console.log(err)
              this.switchs = false
            })
        } else {
          // this.switchs = false
          this.$toast('请先执行报价')
        }
      }
    },
    toOrderList() {
      this.goNext('order')
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>


// WEBPACK FOOTER //
// src/pages/motor/components/quote/index.vue